import { ExamViewComponent } from './../../basic-data/exam-view/exam-view.component';
import { UserViewComponent } from './../../basic-data/user-view/user-view.component';
import { AppTransLazyLoadModule } from '../../app-trans/app-trans-lazyload.module';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule, MatDialogModule, MatIconModule, MatButtonModule, MatRadioModule } from '@angular/material';
import { MaterialModule } from '../../material-module';
import { SatPopoverModule } from '@ncstate/sat-popover';
import { RouterModule } from '@angular/router';
import { AppTransModule, HttpLoaderFactory } from '../../app-trans/app-trans.module';
import { FileNamePipe } from '../pipes/file-name.pipe';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { HttpClientModule, HttpClientJsonpModule, HttpClient } from '@angular/common/http';
import { SidebarModule } from '../../sidebar/sidebar.module';
import { MenuModule } from '../../menu/menu.module';
import { ToastrModule } from 'ngx-toastr';
import { AlertsComponent } from '../components/alerts/alerts.component';
import { NameOfFilePipe } from '../pipes/name-of-file.pipe';
import { OwlModule } from 'ngx-owl-carousel';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EmailExist } from './Validation/EmailExist';
import { LangComponent } from '../components/lang/lang.component';
import { RolePermissionsDirective } from '../directive/role-permissions.directive';



@NgModule({
    imports:      [ CommonModule ,  FormsModule,
        MatInputModule,
        MatDialogModule,
        MaterialModule,
        MatIconModule,
        MatButtonModule,
        ReactiveFormsModule,
        MatRadioModule,
        SatPopoverModule,
    HttpClientModule,
    FormsModule,
    MaterialModule,
    MatButtonModule,
    HttpClientModule,
    HttpClientJsonpModule,
    RouterModule ,
    OwlModule,
    ToastrModule.forRoot(),
    AppTransLazyLoadModule ,NgbModule
    ],
    declarations: [RolePermissionsDirective,  FileNamePipe , NameOfFilePipe  , EmailExist , UserViewComponent , ExamViewComponent
        ],
    exports:      [ RouterModule , FormsModule,
        MatInputModule,
        MatDialogModule,
        MaterialModule,
        MatIconModule,
        MatButtonModule,
        ReactiveFormsModule,
        MatRadioModule,
        SatPopoverModule,


    HttpClientModule,
    FormsModule,
    MaterialModule,
    MatButtonModule,
    HttpClientModule,
    HttpClientJsonpModule,
 RolePermissionsDirective,   FileNamePipe ,NameOfFilePipe,NgbModule,EmailExist, UserViewComponent, ExamViewComponent
       ] ,
        providers: [TranslateService]
   })
export class SharedModule {
}
